/*!
 * Mobile Genome (Development Release)
 * Copyright 2014 NogginLabs, Inc.
 * Authored by: NogginLabs Programming Team
 */

define('screens/multiple-choice/multiple-choice',['require','underscore','backbone','core/templates','core/base-screen','screens/multiple-choice/question','modules/components/feedback'],function(require) {
  'use strict';

  /////////////
  // IMPORTS /{
  /////////////

  var _ = require('underscore');
  var Backbone = require('backbone');
  var templates = require('core/templates');
  var BaseScreen = require('core/base-screen');
  var Question = require('screens/multiple-choice/question');
  var Feedback = require('modules/components/feedback');

  /*****************************************************************************************************************///}

  var MultipleChoice = BaseScreen.extend({

  /////////////////
  // PROPERTIES //{
  /////////////////

    options: {
      shuffleQuestions: false,
      shuffleResponses: false,
      maxAttempts: 2,
      remediation: 'immediate' // immediate, recycle, none
    },

    regions: {
      question: '.question-holder',
      feedback: '.feedback-holder'
    },

    questions: [],
    currentQuestion: null,
    feedback: null,
    disabled: false,
    questionTmpl: null,

  /*****************************************************************************************************************///}

  //////////////
  // METHODS //{
  //////////////

    initialize: function(options)
    {
      BaseScreen.prototype.initialize.apply(this, arguments);

      //console.log('MultipleChoice::initialize');

      this.questionTmpl = templates['screens/multiple-choice/question'];
    },

    onShow: function()
    {
      this.playMedia();

      this.questions = new Backbone.Collection(this.model.get('questions'));

      var self = this;
      this.questions.each(function(question)
      {
        question.set('attempts', self.options.maxAttempts);
      });

      if (this.options.shuffleQuestions)
        this.questions.reset(this.questions.shuffle());

      this.setupQuestion();
    },

    setupQuestion: function()
    {
      //console.log('MultipleChoice::setupQuestion');

      if (this.questions.length)
      {
        this.currentQuestion = this.questions.shift();

        var options = new Backbone.Collection(this.currentQuestion.get('options'));

        var questionView = new Question({ model: this.currentQuestion, collection: options, options: this.options, template: this.questionTmpl });

        questionView.on('option:pressed', this.itemPressed, this);
        this.question.show(questionView);

        var media = this.currentQuestion.get('media');
        if (media && !media.played)
        {
          this.playMedia({ media: media });
          media.played = true;
        }
      }
      else
      {
        this.finish();
      }
    },

    itemPressed: function(option)
    {
      this.question.currentView.disable();
      //console.log(option);

      if (!option.get('correct')) // followup when option is incorrect
      {
        if (this.options.remediation === 'recycle') // add question to end
        {
          //console.log('Recycling question into deck');
          this.questions.push(this.currentQuestion);
        }
        else if (this.options.remediation === 'immediate') // insert question in front
        {
          //console.log('Setting question for immediate remediation');
          this.questions.unshift(this.currentQuestion);
        }
        else
        {
          //console.log('Question is discarded');
        }
      }

      this.checkFeedback(option);

      return false;
    },

    checkFeedback: function(option)
    {
      var feedback = option.get('feedback');
      if (feedback)
      {
        var layout = (option.get('correct')) ? 'correct' : 'incorrect';
        this.showFeedback(feedback, this.setupQuestion, { layout: layout });
      }
      else
      {
        this.setupQuestion();
      }
    },

    showFinalFeedback: function()
    {
      var feedback = this.model.get('feedback');

      if (!feedback)
        return;

      if (feedback['final'])
        this.showFeedback(feedback['final'], null, { layout: 'correct final' });
    },

    showFeedback: function(feedback, onDestroy, params)
    {
      onDestroy = onDestroy || _.noop;
      params = params || { };

      if (!feedback)
      {
        //console.log('Feedback not found.');
        onDestroy();
        return;
      }

      var model = new Backbone.Model(feedback);

      _.each(params, function(value, key)
      {
        model.set(key, value);
      });

      //console.log(params);
      //console.log(model);

      var feedbackView = new Feedback({ model: model });
      feedbackView.on('destroy', onDestroy, this);
      this.feedback.show(feedbackView);
    },

    finish: function()
    {
      BaseScreen.prototype.finish.apply(this, arguments);

      //console.log('MultipleChoice::finish');

      this.showFinalFeedback();
    }

  /*****************************************************************************************************************///}

  });

  return MultipleChoice;

});

